import React, { Suspense, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import Loading from './components/Loading';
import 'e100-react-components/lib/fonts/fonts.css';
import * as Sentry from '@sentry/react';

import store from './store';
import App from './pages/app';
import Translations from './i18n/Translations';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import config from 'config';

if (
  config.serviceName.includes('locator-test') &&
  !window.location.href.includes('localhost')
) {
  Sentry.init({
    dsn: 'http://f2ee3462b04b64930da6f5064eb1519d@dcruvlt-frtlog1.e1.tux:9000/3',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: 1.0,
    normalizeDepth: 10,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <Suspense fallback={<Loading position={'fixed'} align={'center'} />}>
    <Provider store={store}>
      <Translations>
        <App />
      </Translations>
    </Provider>
  </Suspense>,
);
